import { PotentialRevenueDTO } from '../listing/hooks/useListingJobs';

export const getPotentialRevenueString = (data: PotentialRevenueDTO | undefined) => {
  const getPricing = (timeSpan: string) =>
    data?.potentialRevenue && data?.potentialRevenue > 0
      ? `${data?.potentialRevenue ?? 'Not Available'} ${
          data?.potentialRevenueCurrency ?? ''
        }${timeSpan}`
      : 'Not Available';
  switch (data?.potentialRevenueTimeSpan) {
    case 'PerAnnum':
    case 'ANNUALLY':
      return getPricing('');
    case 'PerMonth':
    case 'MONTHLY':
      return getPricing(' / Month');
    case 'HOURLY':
    case 'PerHour':
      return getPricing(' / Hour');
    case 'PerWeek':
    case 'WEEKLY':
      return getPricing(' / Week');
    case 'PerDay':
    case 'DAILY':
      return getPricing(' / Day');
    default:
      return getPricing('');
  }
};
